import bannerIllustration from '../../assets/images/new-courses-banner-illustration.png';

export default function CategoryCoursesHero({ title, description }) {
  return (
    <section className="bg-white">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-4 py-10 sm:px-6 lg:flex-row lg:justify-between lg:py-12">
        <div className="max-w-2xl text-center lg:text-left">
          <h1 className="text-3xl font-bold leading-tight text-[#1A87CC] sm:text-4xl lg:text-[40px]">
            {title}
          </h1>
          <p className="mt-4 text-base leading-relaxed text-[#1B1B1B] sm:text-lg lg:text-[20px]">
            {description}
          </p>
        </div>

        <div className="hidden shrink-0 lg:block">
          <img
            src={bannerIllustration}
            alt=""
            className="h-[220px] w-auto object-contain"
            aria-hidden
          />
        </div>
      </div>
    </section>
  );
}
